// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Video Page Base */
.video-page {
  min-height: 100vh;
  background-color: #0A0A1B;
  padding: 1.5rem;
  
}

.video-page__container {
  max-width: 100%;
  margin: 0 auto;
  padding: 0 2rem;
}

.video-page__content {
  background-color: rgba(17, 24, 39, 0.3);
  border-radius: 1.5rem;
  padding: 2rem;
  border: 1px solid rgb(31, 41, 55);
}

.video-page__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.video-page__title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.02em;
}

.video-page__back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: rgba(55, 65, 81, 0.8);
  color: #e2e8f0;
  border: 1px solid rgba(75, 85, 99, 0.6);
  border-radius: 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.video-page__back-button:hover {
  background-color: rgba(75, 85, 99, 0.8);
  color: white;
  border-color: rgba(107, 114, 128, 0.8);
  transform: translateY(-1px);
}

.video-page__back-button:active {
  transform: translateY(0);
}

.video-page__main-section {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

/* Video Player */
.video-player {
  grid-column: 1 / 2;
}

.video-player__wrapper {
  background-color: rgba(31, 41, 55, 0.5);
  border-radius: 1rem;
  padding: 0.25rem;
  border: 1px solid rgb(55, 65, 81);
}

.video-player__aspect-ratio {
  aspect-ratio: 16 / 9;
  width: 100%;
}

.video-player__iframe {
  width: 100%;
  height: 100%;
  border-radius: 0.75rem;
}

.video-player__placeholder {
  width: 100%;
  height: 100%;
  border-radius: 0.75rem;
  background-color: rgb(31, 41, 55);
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-player__placeholder-content {
  text-align: center;
}

.video-player__thumbnail {
  max-width: 100%;
  max-height: 100%;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}

.video-player__youtube-link {
  display: inline-flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  background-color: rgb(220, 38, 38);
  color: white;
  border-radius: 0.75rem;
  transition: background-color 0.3s;
}

.video-player__youtube-link:hover {
  background-color: rgb(185, 28, 28);
}

/* Transcript Panel */
.transcript-panel {
  grid-column: 2 / 3;
}

.transcript-panel__content {
  background-color: rgba(31, 41, 55, 0.5);
  border-radius: 1rem;
  padding: 1.5rem;
  border: 1px solid rgb(55, 65, 81);
  height: 100%;
}

.transcript-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.transcript-panel__title {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.01em;
}

.transcript-panel__search {
  display: flex;
  align-items: center;
  flex-shrink: 1;
  min-width: 0;
}

.transcript-panel__search-input {
  background-color: rgba(31, 41, 55, 0.7);
  border: 1px solid rgb(55, 65, 81);
  border-radius: 0.375rem;
  padding: 0.375rem 0.75rem;
  color: white;
  font-size: 0.875rem;
  width: 160px;
  height: 32px;
  transition: all 0.2s ease;
}

.transcript-panel__search-input:focus {
  outline: none;
  border-color: rgb(96, 165, 250);
  box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.2);
}

.transcript-panel__search-input::placeholder {
  color: rgb(156, 163, 175);
}

.transcript-panel__body {
  height: 25rem;
  overflow-y: auto;
}

/* Tabs */
.tabs {
  width: 100%;
  margin-bottom: 2rem;
}

.tabs__nav {
  display: flex;
  background-color: rgba(55, 65, 81, 0.3);
  border-radius: 0.5rem;
  padding: 0.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(55, 65, 81, 0.3);
}

.tabs__button {
  flex: 1 1;
  padding: 0.75rem 1.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #94a3b8;
  transition: all 0.2s ease;
  position: relative;
  text-align: center;
  border: none;
  background: transparent;
}

.tabs__button:hover {
  color: #e2e8f0;
}

.tabs__button--active {
  color: #ffffff;
  background-color: #2563eb;
  border-radius: 0.375rem;
}

.tabs__button:not(:last-child) {
  border-right: none;
}

.tabs__content {
  background-color: rgba(31, 41, 55, 0.5);
  border-radius: 1rem;
  padding: 2rem;
  border: 1px solid rgb(55, 65, 81);
  min-height: 24rem;
}

/* Error and Not Found States */
.video-page--error,
.video-page--not-found {
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-container,
.not-found-container {
  text-align: center;
}

.error-message {
  color: rgb(248, 113, 113);
}

.not-found-message {
  color: white;
}

/* Animations */
.slide-in-right {
  animation: slideInRight 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(60px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Custom Scrollbar */
.transcript-panel__body::-webkit-scrollbar {
  width: 6px;
}

.transcript-panel__body::-webkit-scrollbar-track {
  background: rgba(55, 65, 81, 0.3);
  border-radius: 3px;
}

.transcript-panel__body::-webkit-scrollbar-thumb {
  background: rgba(107, 114, 128, 0.5);
  border-radius: 3px;
}

.transcript-panel__body::-webkit-scrollbar-thumb:hover {
  background: rgba(107, 114, 128, 0.7);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .video-page__main-section {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .video-player,
  .transcript-panel {
    grid-column: 1;
  }
  
  .video-page__back-button {
    padding: 0.7rem 1.3rem;
    font-size: 0.85rem;
  }
}

@media (max-width: 768px) {
  .video-page__container {
    padding: 0 1rem;
  }
  
  .video-page__back-button {
    padding: 0.65rem 1.2rem;
    font-size: 0.8rem;
  }
  
  .video-page__title {
    font-size: 1.3rem;
  }
}

@media (max-width: 640px) {
  .video-page {
    padding: 0.5rem;
  }
  
  .video-page__container {
    padding: 0;
  }
  
  .video-page__content {
    padding: 0.75rem;
    border-radius: 1rem;
  }
  
  .video-page__header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .video-page__title {
    font-size: 1.2rem;
  }
  
  .video-page__back-button {
    align-self: flex-start;
    padding: 0.625rem 1.25rem;
    font-size: 0.8125rem;
  }
  
  .transcript-panel__header {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
  }
  
  .transcript-panel__title {
    font-size: 1rem;
    white-space: nowrap;
    flex-shrink: 0;
  }
  
  .transcript-panel__search {
    flex-shrink: 1;
    min-width: 0;
  }
  
  .transcript-panel__search-input {
    width: 120px;
    min-width: 100px;
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }
  
  .tabs__nav {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  
  .tabs__button {
    padding: 0.625rem 1rem;
    font-size: 0.75rem;
    min-width: calc(33.333% - 0.35rem);
    flex: 0 0 auto;
  }
}

@media (max-width: 480px) {
  .video-page {
    padding: 0.25rem;
  }
  
  .video-page__container {
    padding: 0;
  }
  
  .video-page__content {
    padding: 0.5rem;
    border-radius: 0.25rem;
  }
  
  .video-page__back-button {
    padding: 0.5rem 1rem;
    font-size: 0.75rem;
    gap: 0.4rem;
  }
  
  .video-page__title {
    font-size: 1.1rem;
  }
  
  .transcript-panel__title {
    font-size: 0.9rem;
  }
  
  .transcript-panel__search-input {
    width: 100px;
    min-width: 80px;
    padding: 0.25rem 0.4rem;
    font-size: 0.7rem;
  }
  
  .tabs__button {
    padding: 0.5rem 0.8rem;
    font-size: 0.7rem;
  }
}

@media (max-width: 380px) {
  .video-page {
    padding: 0.125rem;
  }
  
  .video-page__container {
    padding: 0;
  }
  
  .video-page__content {
    padding: 0.4rem;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
  
  .video-page__back-button {
    padding: 0.4rem 0.8rem;
    font-size: 0.7rem;
    gap: 0.3rem;
  }
  
  .video-page__title {
    font-size: 1rem;
  }
  
  .transcript-panel__title {
    font-size: 0.85rem;
  }
  
  .transcript-panel__search-input {
    width: 90px;
    min-width: 70px;
    padding: 0.2rem 0.3rem;
    font-size: 0.65rem;
  }
  
  .tabs__button {
    padding: 0.4rem 0.6rem;
    font-size: 0.65rem;
  }
}

@media (max-width: 320px) {
  .video-page {
    padding: 0;
  }
  
  .video-page__content {
    padding: 0.3rem;
    border-radius: 0;
    border: none;
    background-color: rgba(17, 24, 39, 0.5);
  }
  
  .video-page__back-button {
    padding: 0.35rem 0.7rem;
    font-size: 0.65rem;
    gap: 0.25rem;
  }
  
  .video-page__title {
    font-size: 0.9rem;
  }
  
  .transcript-panel__title {
    font-size: 0.8rem;
  }
  
  .transcript-panel__search-input {
    width: 80px;
    min-width: 60px;
    padding: 0.15rem 0.25rem;
    font-size: 0.6rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/VideoPage.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;;AAEjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;EACrB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,uCAAuC;EACvC,cAAc;EACd,uCAAuC;EACvC,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,YAAY;EACZ,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE,yDAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kCAAkC;IAClC,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uCAAuC;EACzC;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,wBAAwB;IACxB,iBAAiB;EACnB;AACF","sourcesContent":["/* Video Page Base */\n.video-page {\n  min-height: 100vh;\n  background-color: #0A0A1B;\n  padding: 1.5rem;\n  \n}\n\n.video-page__container {\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.video-page__content {\n  background-color: rgba(17, 24, 39, 0.3);\n  border-radius: 1.5rem;\n  padding: 2rem;\n  border: 1px solid rgb(31, 41, 55);\n}\n\n.video-page__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.video-page__title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -0.02em;\n}\n\n.video-page__back-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background-color: rgba(55, 65, 81, 0.8);\n  color: #e2e8f0;\n  border: 1px solid rgba(75, 85, 99, 0.6);\n  border-radius: 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.video-page__back-button:hover {\n  background-color: rgba(75, 85, 99, 0.8);\n  color: white;\n  border-color: rgba(107, 114, 128, 0.8);\n  transform: translateY(-1px);\n}\n\n.video-page__back-button:active {\n  transform: translateY(0);\n}\n\n.video-page__main-section {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n/* Video Player */\n.video-player {\n  grid-column: 1 / 2;\n}\n\n.video-player__wrapper {\n  background-color: rgba(31, 41, 55, 0.5);\n  border-radius: 1rem;\n  padding: 0.25rem;\n  border: 1px solid rgb(55, 65, 81);\n}\n\n.video-player__aspect-ratio {\n  aspect-ratio: 16 / 9;\n  width: 100%;\n}\n\n.video-player__iframe {\n  width: 100%;\n  height: 100%;\n  border-radius: 0.75rem;\n}\n\n.video-player__placeholder {\n  width: 100%;\n  height: 100%;\n  border-radius: 0.75rem;\n  background-color: rgb(31, 41, 55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.video-player__placeholder-content {\n  text-align: center;\n}\n\n.video-player__thumbnail {\n  max-width: 100%;\n  max-height: 100%;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.video-player__youtube-link {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.75rem 1.5rem;\n  background-color: rgb(220, 38, 38);\n  color: white;\n  border-radius: 0.75rem;\n  transition: background-color 0.3s;\n}\n\n.video-player__youtube-link:hover {\n  background-color: rgb(185, 28, 28);\n}\n\n/* Transcript Panel */\n.transcript-panel {\n  grid-column: 2 / 3;\n}\n\n.transcript-panel__content {\n  background-color: rgba(31, 41, 55, 0.5);\n  border-radius: 1rem;\n  padding: 1.5rem;\n  border: 1px solid rgb(55, 65, 81);\n  height: 100%;\n}\n\n.transcript-panel__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.transcript-panel__title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin: 0;\n  white-space: nowrap;\n  flex-shrink: 0;\n  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -0.01em;\n}\n\n.transcript-panel__search {\n  display: flex;\n  align-items: center;\n  flex-shrink: 1;\n  min-width: 0;\n}\n\n.transcript-panel__search-input {\n  background-color: rgba(31, 41, 55, 0.7);\n  border: 1px solid rgb(55, 65, 81);\n  border-radius: 0.375rem;\n  padding: 0.375rem 0.75rem;\n  color: white;\n  font-size: 0.875rem;\n  width: 160px;\n  height: 32px;\n  transition: all 0.2s ease;\n}\n\n.transcript-panel__search-input:focus {\n  outline: none;\n  border-color: rgb(96, 165, 250);\n  box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.2);\n}\n\n.transcript-panel__search-input::placeholder {\n  color: rgb(156, 163, 175);\n}\n\n.transcript-panel__body {\n  height: 25rem;\n  overflow-y: auto;\n}\n\n/* Tabs */\n.tabs {\n  width: 100%;\n  margin-bottom: 2rem;\n}\n\n.tabs__nav {\n  display: flex;\n  background-color: rgba(55, 65, 81, 0.3);\n  border-radius: 0.5rem;\n  padding: 0.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(55, 65, 81, 0.3);\n}\n\n.tabs__button {\n  flex: 1;\n  padding: 0.75rem 1.25rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #94a3b8;\n  transition: all 0.2s ease;\n  position: relative;\n  text-align: center;\n  border: none;\n  background: transparent;\n}\n\n.tabs__button:hover {\n  color: #e2e8f0;\n}\n\n.tabs__button--active {\n  color: #ffffff;\n  background-color: #2563eb;\n  border-radius: 0.375rem;\n}\n\n.tabs__button:not(:last-child) {\n  border-right: none;\n}\n\n.tabs__content {\n  background-color: rgba(31, 41, 55, 0.5);\n  border-radius: 1rem;\n  padding: 2rem;\n  border: 1px solid rgb(55, 65, 81);\n  min-height: 24rem;\n}\n\n/* Error and Not Found States */\n.video-page--error,\n.video-page--not-found {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.error-container,\n.not-found-container {\n  text-align: center;\n}\n\n.error-message {\n  color: rgb(248, 113, 113);\n}\n\n.not-found-message {\n  color: white;\n}\n\n/* Animations */\n.slide-in-right {\n  animation: slideInRight 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(60px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Custom Scrollbar */\n.transcript-panel__body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.transcript-panel__body::-webkit-scrollbar-track {\n  background: rgba(55, 65, 81, 0.3);\n  border-radius: 3px;\n}\n\n.transcript-panel__body::-webkit-scrollbar-thumb {\n  background: rgba(107, 114, 128, 0.5);\n  border-radius: 3px;\n}\n\n.transcript-panel__body::-webkit-scrollbar-thumb:hover {\n  background: rgba(107, 114, 128, 0.7);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .video-page__main-section {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .video-player,\n  .transcript-panel {\n    grid-column: 1;\n  }\n  \n  .video-page__back-button {\n    padding: 0.7rem 1.3rem;\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .video-page__container {\n    padding: 0 1rem;\n  }\n  \n  .video-page__back-button {\n    padding: 0.65rem 1.2rem;\n    font-size: 0.8rem;\n  }\n  \n  .video-page__title {\n    font-size: 1.3rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .video-page {\n    padding: 0.5rem;\n  }\n  \n  .video-page__container {\n    padding: 0;\n  }\n  \n  .video-page__content {\n    padding: 0.75rem;\n    border-radius: 1rem;\n  }\n  \n  .video-page__header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  \n  .video-page__title {\n    font-size: 1.2rem;\n  }\n  \n  .video-page__back-button {\n    align-self: flex-start;\n    padding: 0.625rem 1.25rem;\n    font-size: 0.8125rem;\n  }\n  \n  .transcript-panel__header {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.75rem;\n  }\n  \n  .transcript-panel__title {\n    font-size: 1rem;\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n  \n  .transcript-panel__search {\n    flex-shrink: 1;\n    min-width: 0;\n  }\n  \n  .transcript-panel__search-input {\n    width: 120px;\n    min-width: 100px;\n    padding: 0.25rem 0.5rem;\n    font-size: 0.75rem;\n  }\n  \n  .tabs__nav {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n  \n  .tabs__button {\n    padding: 0.625rem 1rem;\n    font-size: 0.75rem;\n    min-width: calc(33.333% - 0.35rem);\n    flex: 0 0 auto;\n  }\n}\n\n@media (max-width: 480px) {\n  .video-page {\n    padding: 0.25rem;\n  }\n  \n  .video-page__container {\n    padding: 0;\n  }\n  \n  .video-page__content {\n    padding: 0.5rem;\n    border-radius: 0.25rem;\n  }\n  \n  .video-page__back-button {\n    padding: 0.5rem 1rem;\n    font-size: 0.75rem;\n    gap: 0.4rem;\n  }\n  \n  .video-page__title {\n    font-size: 1.1rem;\n  }\n  \n  .transcript-panel__title {\n    font-size: 0.9rem;\n  }\n  \n  .transcript-panel__search-input {\n    width: 100px;\n    min-width: 80px;\n    padding: 0.25rem 0.4rem;\n    font-size: 0.7rem;\n  }\n  \n  .tabs__button {\n    padding: 0.5rem 0.8rem;\n    font-size: 0.7rem;\n  }\n}\n\n@media (max-width: 380px) {\n  .video-page {\n    padding: 0.125rem;\n  }\n  \n  .video-page__container {\n    padding: 0;\n  }\n  \n  .video-page__content {\n    padding: 0.4rem;\n    border-radius: 0;\n    border-left: none;\n    border-right: none;\n  }\n  \n  .video-page__back-button {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.7rem;\n    gap: 0.3rem;\n  }\n  \n  .video-page__title {\n    font-size: 1rem;\n  }\n  \n  .transcript-panel__title {\n    font-size: 0.85rem;\n  }\n  \n  .transcript-panel__search-input {\n    width: 90px;\n    min-width: 70px;\n    padding: 0.2rem 0.3rem;\n    font-size: 0.65rem;\n  }\n  \n  .tabs__button {\n    padding: 0.4rem 0.6rem;\n    font-size: 0.65rem;\n  }\n}\n\n@media (max-width: 320px) {\n  .video-page {\n    padding: 0;\n  }\n  \n  .video-page__content {\n    padding: 0.3rem;\n    border-radius: 0;\n    border: none;\n    background-color: rgba(17, 24, 39, 0.5);\n  }\n  \n  .video-page__back-button {\n    padding: 0.35rem 0.7rem;\n    font-size: 0.65rem;\n    gap: 0.25rem;\n  }\n  \n  .video-page__title {\n    font-size: 0.9rem;\n  }\n  \n  .transcript-panel__title {\n    font-size: 0.8rem;\n  }\n  \n  .transcript-panel__search-input {\n    width: 80px;\n    min-width: 60px;\n    padding: 0.15rem 0.25rem;\n    font-size: 0.6rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
